import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { Whatsapp } from 'app/components/Icons'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { HeaderContext } from 'app/containers/Header'
import { styles, theme } from 'app/theme'
import React, { memo, useContext } from 'react'
import { isMobile } from 'react-device-detect'

export interface Props {
  variant?: Variant
  modalStatus?: boolean
  siteName?: string
  startAnimation?: boolean
}

export const Contacts = memo(function Contacts({
  variant = 'default',
  modalStatus,
  siteName,
}: Props) {
  const { whatsappURL } = useContext(HeaderContext) as any

  return (
    <Container variant={variant} className="open item-contacts">
      {variant === 'mobile' ? (
        <>
          {whatsappURL ? (
            <Anchor
              aria-label="link"
              href={whatsappURL}
              rel="noopener"
              target="_blank"
              onClick={() => {
                typeof window.gtag !== 'undefined' &&
                  window.gtag('event', 'Click', {
                    event_category: 'Website',
                    event_label: 'Whatsapp Number',
                  })
              }}
            >
              <Whatsapp />
            </Anchor>
          ) : null}
        </>
      ) : (
        <Label row>
          {siteName ? (
            <SiteName dial={4} row>
              {siteName}
            </SiteName>
          ) : null}
          Roma
        </Label>
      )}
    </Container>
  )
})

const Anchor = styled.a`
  color: ${theme.colors.variants.neutralLight3};
  line-height: 1rem;
  margin-top: 1.375rem;
  margin-right: 1.5rem;

  svg {
    fill: ${theme.colors.variants.neutralLight3};
    position: relative;
    width: 1.125rem;
    height: 1.125rem;
  }

  &:hover {
    opacity: 0.5;
  }
`

const Container = styled.div<ContainerProps>`
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  opacity: 0;
  transform: translateY(1.875rem);
  position: absolute;
  display: flex;

  &.open {
    opacity: 1;
    transform: none;
    transition: 0.6s 0.4s cubic-bezier(0, 0.55, 0.45, 1);
  }

  ${({ variant }) => {
    switch (variant) {
      case 'default':
        return css`
          @media (max-width: 1199px) {
            display: none;
          }
        `
      case 'mobile':
        return css`
          position: relative;
        `
    }
  }};
`

const Label = styled(FlexBox)`
  ${styles.label}

  color: ${theme.colors.variants.neutralDark1};
`

const SiteName = styled(FlexBox)`
  &:after {
    content: '';
    width: 1.75rem;
    height: 0.125rem;
    background: ${theme.colors.variants.primaryDark};
    margin: 0 1rem;
  }
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'mobile' | 'default'
